import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';
export const TextDeletionInputContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextDeletionInputHeaderStyled = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
`;

export const TextDeletionInpuDescription = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin-bottom: 10px;
  font-weight: 500;
`;
export const TextDeletionEmptyStyled = styled(TextDeletionInputContainerStyled)`
  padding: 20px;
`;
export const TextDeletionEmptyDivStyled = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  width: 100%;
  padding: 20px;
  font-weight: 600;
`;
